// Rabbit — garbage bet. Win a hole outright to "grab the rabbit"; you hold it
// until someone else wins a hole outright. Whoever holds it at the turn (after
// hole 9) wins the front pot; the holder after 18 wins the back pot.
// GolfGamesScorecard routes 'rabbit' to calcStroke for standings (UI-tracked
// bet, no canonical engine). We mirror that + a faithful holder tracker.
export { calcStroke } from './ggStrokePlay.js'

/** Outright-low hole winner per hole across the field (null when tied). */
export function holeWinners(players) {
  return Array.from({ length: 18 }, (_, h) => {
    const entries = (players || [])
      .map((p) => ({ id: p.id, s: p.scores[h] }))
      .filter((e) => e.s != null)
    if (!entries.length) return null
    const min = Math.min(...entries.map((e) => e.s))
    const winners = entries.filter((e) => e.s === min)
    return winners.length === 1 ? winners[0].id : null
  })
}

/**
 * Track the rabbit: holder passes to each new outright hole-winner and is held
 * through halved holes. Snapshots the holder after hole 9 and hole 18.
 */
export function computeRabbit(winners, { frontPot = 0, backPot = 0 } = {}) {
  let holder = null
  const holderByHole = []
  for (let h = 0; h < 18; h++) {
    if (winners[h]) holder = winners[h]
    holderByHole[h] = holder
  }
  const frontHolder = holderByHole[8] ?? null
  const backHolder = holderByHole[17] ?? null
  const payouts = {}
  const add = (id, amt) => { if (id && amt > 0) payouts[id] = (payouts[id] || 0) + amt }
  add(frontHolder, Number(frontPot) || 0)
  add(backHolder, Number(backPot) || 0)
  return { frontHolder, backHolder, holderByHole, payouts }
}

// ── Auto-settle (ON): compute everything from the scorecard alone ────────────
export function autoRabbit(players, pots = {}) {
  return computeRabbit(holeWinners(players), pots)
}

// ── Manual (OFF, fallback): settle from holders you tracked yourself ─────────
export function manualRabbit(frontHolder, backHolder, { frontPot = 0, backPot = 0 } = {}) {
  const payouts = {}
  const add = (id, amt) => { if (id && amt > 0) payouts[id] = (payouts[id] || 0) + amt }
  add(frontHolder, Number(frontPot) || 0)
  add(backHolder, Number(backPot) || 0)
  return { frontHolder: frontHolder ?? null, backHolder: backHolder ?? null, holderByHole: [], payouts }
}
